var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.conditionsList),function(condition){return [_c('div',{key:condition.text,class:{
        'list-item': true,
        'list-item--error': !condition.test_res,
        'list-item--success': condition.test_res
      }},[_vm._v(" "+_vm._s(condition.text)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }